// Internal Dependencies
import { eventFetchSuccess } from './action-creator';
import { firebaseRef } from '../../config/constants';

// Local variables
const EventData = firebaseRef.child('event');

// Action Defintions
export const getNextEvent = () =>
  dispatch =>
    EventData.on('value', (snapshot) => {
      dispatch(eventFetchSuccess(snapshot.val()));
    });

export default {
  getNextEvent,
};



/** WEBPACK FOOTER **
 ** ./src/state/actions/event-actions.js
 **/